<template>
    <div>
        <top-carousel></top-carousel>
        <div class="client container">
            <div class="row">
                <!-- <figure class="col-xs-6 col-sm-3 col-md-3 col-lg-20">
                    <a href="https://new.siemens.com/cn/zh.html" target="_blank"
                        ><img
                            src="../../../../assets/img/mainPage/p1.jpg"
                            title="SIEMENS"
                        />
                    </a>
                </figure>
                <figure class="col-xs-6 col-sm-3 col-md-3 col-lg-20">
                    <a
                        href="https://www.schneider-electric.cn/zh/"
                        target="_blank"
                        ><img
                            src="../../../../assets/img/mainPage/p2.jpg"
                            title="SCHNERDER"
                        />
                    </a>
                </figure>
                <figure class="col-xs-6 col-sm-3 col-md-3 col-lg-20">
                    <a href="https://www.johnsoncontrols.com/" target="_blank"
                        ><img
                            src="../../../../assets/img/mainPage/p3.jpg"
                            title="JOHNSON"
                        />
                    </a>
                </figure>
                <figure class="col-xs-6 col-sm-3 col-md-3 col-lg-20">
                    <a
                        href="https://www.rockwellautomation.com.cn/"
                        target="_blank"
                        ><img
                            src="../../../../assets/img/mainPage/p4.jpg"
                            title="ROCKWELL"
                        />
                    </a>
                </figure>
                <figure class="col-xs-6 col-sm-3 col-md-3 col-lg-20">
                    <a href="https://www.honeywell.com.cn/" target="_blank"
                        ><img
                            src="../../../../assets/img/mainPage/p5.jpg"
                            title="Honeywell"
                        />
                    </a>
                </figure>
                <figure class="col-xs-6 col-sm-3 col-md-3 col-lg-20">
                    <a href="http://www.bray.com.cn/" target="_blank"
                        ><img
                            src="../../../../assets/img/mainPage/p6.jpg"
                            title="Bray"
                        />
                    </a>
                </figure>
                <figure class="col-xs-6 col-sm-3 col-md-3 col-lg-20">
                    <a href="http://www.abb.com.cn" target="_blank"
                        ><img
                            src="../../../../assets/img/mainPage/p7.jpg"
                            title="ABB"
                        />
                    </a>
                </figure>
                <figure class="col-xs-6 col-sm-3 col-md-3 col-lg-20">
                    <a href="http://kimo-instruments.com" target="_blank"
                        ><img
                            src="../../../../assets/img/mainPage/p8.jpg"
                            title="kimo"
                        />
                    </a>
                </figure>
                <figure class="col-xs-6 col-sm-3 col-md-3 col-lg-20">
                    <a href="https://www.belimo.com.cn/zh_CN/" target="_blank"
                        ><img
                            src="../../../../assets/img/mainPage/p9.jpg"
                            title="belimo"
                        />
                    </a>
                </figure>
                <figure class="col-xs-6 col-sm-3 col-md-3 col-lg-20">
                    <a href="https://www.vaisala.com/en" target="_blank"
                        ><img
                            src="../../../../assets/img/mainPage/p10.jpg"
                            title="VAISALA"
                        />
                    </a>
                </figure>
                <figure class="col-xs-6 col-sm-3 col-md-3 col-lg-20">
                    <a href="https://www.emerson.com/global" target="_blank">
                        <img
                            src="../../../../assets/img/mainPage/p11.jpg"
                            title="EMERSON"
                        />
                    </a>
                </figure>
                <figure class="col-xs-6 col-sm-3 col-md-3 col-lg-20">
                    <a href="https://www.epluse.com/" target="_blank"
                        ><img
                            src="../../../../assets/img/mainPage/p12.jpg"
                            title="ELEKTRONIK"
                        />
                    </a>
                </figure> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
.client {
    margin-top: 60px;
    margin-bottom: 30px;
}
.client figure {
    margin-bottom: 30px;
}
.client figure > a {
    position: relative;
    display: block;
    background: #fff;
}
.client .row figure img {
    display: block;
    max-width: 100%;
    margin: 0 auto;
    padding: 20px 0;
    &:hover {
        transform: scale(1.1);
        transition: all 0.3s ease-in;
    }
}
</style>
